export default {
    name: 'videoservice',
    callable() {
        function playVideo(ele) {
            if (ele.querySelector('iframe')) {
                const iframe = ele.querySelector('iframe');
                if (iframe.src.indexOf('vimeo') !== -1) {
                    iframe.contentWindow.postMessage(
                        JSON.stringify({ method: 'play' }),
                        iframe.src
                    );
                }
                if (iframe.src.indexOf('youtube') !== -1) {
                    const command = window.JSON.stringify({
                        event: 'command',
                        func: 'playVideo',
                    });
                    iframe.contentWindow.postMessage(command, iframe.src);
                }
            }
        }

        function stopVideo(ele) {
            if (ele.querySelector('iframe')) {
                const iframe = ele.querySelector('iframe');
                if (iframe.src.indexOf('vimeo') !== -1) {
                    iframe.contentWindow.postMessage(
                        JSON.stringify({ method: 'unload' }),
                        iframe.src
                    );
                }
                if (iframe.src.indexOf('youtube') !== -1) {
                    const command = window.JSON.stringify({
                        event: 'command',
                        func: 'stopVideo',
                    });
                    iframe.contentWindow.postMessage(command, iframe.src);
                }
            }
        }

        return {
            playVideo,
            stopVideo,
        };
    },
};



// WEBPACK FOOTER //
// ./services/videoservice.js